import { render } from "./ReportsPageTable.vue?vue&type=template&id=e4773a90&ts=true"
import script from "./ReportsPageTable.vue?vue&type=script&lang=ts"
export * from "./ReportsPageTable.vue?vue&type=script&lang=ts"

import "./ReportsPageTable.vue?vue&type=style&index=0&id=e4773a90&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__